export enum VariantPaintType {
  READYMIXED = 'ReadyMixed',
  TINTED = 'Tinted',
}
